// extracted by mini-css-extract-plugin
export var fullHeightState = "_1w-7";
export var headerCell = "_1w-1";
export var loadingStateCell = "_1w-4";
export var rowWrapper = "_1w-3";
export var standaloneTable = "_1w-8";
export var standaloneTableWithBodyFill = "_1w-9";
export var stateCell = "_1w-5";
export var table = "_1w-0";
export var tableBodyFiller = "_1w-6";
export var white = "_1w-2";